'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var Loads = require('react-loads');
var bumbag = require('bumbag');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Loads__default = /*#__PURE__*/_interopDefaultLegacy(Loads);

var DataList = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose__default["default"](DataList, _React$Component);

  function DataList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "state", {
      currentPage: 1,
      pageCount: _this.props.pageCount || 1,
      items: _this.props.items || []
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "getData", /*#__PURE__*/_asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee() {
      var loadData, currentPage, data, items;
      return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loadData = _this.props.loadData;
              currentPage = _this.state.currentPage;
              _context.next = 4;
              return loadData({
                page: currentPage
              });

            case 4:
              data = _context.sent;
              items = [].concat(_this.state.items, data.items);

              _this.setState({
                items: items,
                pageCount: data.pageCount
              });

              return _context.abrupt("return", items);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "getMoreData", function (_ref2) {
      var getData = _ref2.getData;
      // eslint-disable-line
      var currentPage = _this.state.currentPage;

      _this.setState({
        currentPage: currentPage + 1
      }, function () {
        return getData();
      });
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "render", function () {
      var _this$props = _this.props,
          contextKey = _this$props.contextKey,
          dataRenderer = _this$props.dataRenderer,
          errorRenderer = _this$props.errorRenderer,
          loadingRenderer = _this$props.loadingRenderer,
          loadMoreRenderer = _this$props.loadMoreRenderer;
      var _this$state = _this.state,
          currentPage = _this$state.currentPage,
          pageCount = _this$state.pageCount;
      return /*#__PURE__*/React__default["default"].createElement(Loads__default["default"], {
        contextKey: contextKey,
        loadOnMount: true,
        load: _this.getData
      }, function (_ref3) {
        var load = _ref3.load,
            items = _ref3.response,
            error = _ref3.error,
            isError = _ref3.isError,
            isIdle = _ref3.isIdle,
            isLoading = _ref3.isLoading,
            isSuccess = _ref3.isSuccess;
        return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, isSuccess && dataRenderer({
          items: items || _this.state.items
        }), (isIdle || isLoading) && loadingRenderer && loadingRenderer(), isError && errorRenderer && errorRenderer({
          error: error
        }), currentPage < pageCount && /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, loadMoreRenderer({
          isLoading: isLoading,
          loadMore: function loadMore() {
            return _this.getMoreData({
              getData: load
            });
          }
        })));
      });
    });

    return _this;
  }

  return DataList;
}(React__default["default"].Component);

_defineProperty__default["default"](DataList, "defaultProps", {
  contextKey: null,
  errorRenderer: function errorRenderer() {
    return null;
  },
  loadingRenderer: function loadingRenderer() {
    return null;
  },
  pageCount: 1,
  items: []
});

exports["default"] = DataList;
